import {
    GET_LIST_DANHSACHDONHANG,
    GET_LIST_DANHSACHDONHANG_SUCCESS,
    GET_LIST_DANHSACHDONHANG_FAILURE,
    UPDATE_SEARCHTDATA_DANHSACHDONHANG,
    UPDATE_DANHSACHDONHANG,
} from "./actionTypes";

export const getListDanhSachDonHang = (dataSearch) => ({
    type: GET_LIST_DANHSACHDONHANG,
    dataSearch,
});
export const getListDanhSachDonHangSuccess = (data) => ({
    type: GET_LIST_DANHSACHDONHANG_SUCCESS,
    payload: data,
});
export const getListDanhSachDonHangFailure = (dataSearch) => ({
    type: GET_LIST_DANHSACHDONHANG_FAILURE,
});
export const updateDataSearch = (data) => ({
    type: UPDATE_SEARCHTDATA_DANHSACHDONHANG,
    payload: data,
});

export const updateListDanhSachDonHang = (data) => ({
    type: UPDATE_DANHSACHDONHANG,
    payload: data,
});
